"use strict";

var paymentProcessorFormatter = require("./paymentProcessor.formatter");
var multipleChoiceFormatter = require("./multipleChoice.formatter");
var connectionFormatter = require("./connection.formatter");
var signatureFormatter = require("./signature.formatter");
var currencyFormatter = require("./currency.formatter");
var equationFormatter = require("./equation.formatter");
var addressFormatter = require("./address.formatter");
var booleanFormatter = require("./boolean.formatter");
var profileFormatter = require("./profile.formatter");
var numberFormatter = require("./number.formatter");
var stringFormatter = require("./string.formatter");
var emailFormatter = require("./email.formatter");
var imageFormatter = require("./image.formatter");
var phoneFormatter = require("./phone.formatter");
var timerFormatter = require("./timer.formatter");
var dateFormatter = require("./date.formatter");
var fileFormatter = require("./file.formatter");
var linkFormatter = require("./link.formatter");
var nameFormatter = require("./name.formatter");
module.exports = {
  paymentProcessor: paymentProcessorFormatter,
  multipleChoice: multipleChoiceFormatter,
  connection: connectionFormatter,
  signature: signatureFormatter,
  currency: currencyFormatter,
  equation: equationFormatter,
  address: addressFormatter,
  "boolean": booleanFormatter,
  profile: profileFormatter,
  number: numberFormatter,
  string: stringFormatter,
  email: emailFormatter,
  image: imageFormatter,
  phone: phoneFormatter,
  timer: timerFormatter,
  date: dateFormatter,
  file: fileFormatter,
  link: linkFormatter,
  name: nameFormatter
};